import HomeIcon from '../../Components/CustomIcons/HomeIcon';
import CommercialIcon from '../../Components/CustomIcons/CommercialIcon';
import IndustrialIcon from '../../Components/CustomIcons/IndustrialIcon';
import OthersContratcsIcon from '../../Components/CustomIcons/OthersContratcsIcon';
import { Portal, portal } from '../../Configs/general';

export const CONTRACT_TYPES = {
  Residential: 1,
  Commercial: 2,
  Industrial: 3,
  Unregulated: 6,
  ServiceStation: 7,
  SecondaryMarket: 14,
  Construction: 12
};

export const CONTRACT_PRODUCT_TYPES = {
  Gas: 7014,
  Generic: 6121
};

const INVOICE_CONTRACTS_LIST = {
  [Portal.Gascaribe]: [
    CONTRACT_TYPES.Residential,
    CONTRACT_TYPES.Commercial,
    CONTRACT_TYPES.Industrial,
    CONTRACT_TYPES.Unregulated,
    CONTRACT_TYPES.ServiceStation,
    CONTRACT_TYPES.SecondaryMarket,
    CONTRACT_TYPES.Construction
  ],
  [Portal.Gasguajira]: [
    CONTRACT_TYPES.Residential,
    CONTRACT_TYPES.Commercial,
    CONTRACT_TYPES.Industrial
  ],
  [Portal.Efigas]: [
    CONTRACT_TYPES.Residential,
    CONTRACT_TYPES.Commercial,
    CONTRACT_TYPES.Industrial,
    CONTRACT_TYPES.Unregulated,
    CONTRACT_TYPES.ServiceStation,
    CONTRACT_TYPES.SecondaryMarket,
    CONTRACT_TYPES.Construction
  ]
};

export const INVOICE_CONTRACTS = INVOICE_CONTRACTS_LIST[portal];

export const SPECIAL_CONTRACTS = [
  CONTRACT_TYPES.Unregulated,
  CONTRACT_TYPES.ServiceStation,
  CONTRACT_TYPES.SecondaryMarket,
  CONTRACT_TYPES.Construction
];

export const DEFAULT_ALIASES = {
  [CONTRACT_TYPES.Residential]: 'Casa',
  [CONTRACT_TYPES.Commercial]: 'Comercio',
  [CONTRACT_TYPES.Industrial]: 'Industria',
  [CONTRACT_TYPES.Unregulated]: 'NoRegulado',
  [CONTRACT_TYPES.ServiceStation]: 'EstaciónServ',
  [CONTRACT_TYPES.SecondaryMarket]: 'MercadoSec',
  [CONTRACT_TYPES.Construction]: 'Constructora'
};

export const renderContractTypeDescription = type => {
  switch (type) {
    case CONTRACT_TYPES.Residential:
      return 'Residencial';
    case CONTRACT_TYPES.Commercial:
      return 'Comercial';
    case CONTRACT_TYPES.Industrial:
      return 'Industrial';
    case CONTRACT_TYPES.Unregulated:
      return 'No regulado';
    case CONTRACT_TYPES.ServiceStation:
      return 'Estación de servicio';
    case CONTRACT_TYPES.SecondaryMarket:
      return 'Mercado secundario';
    case CONTRACT_TYPES.Construction:
      return 'Constructora';
    default:
      return 'Otro';
  }
};

export const ICON_SELECT_OPTIONS = [
  {
    label: '',
    value: 1,
    image: HomeIcon
  },
  {
    label: '',
    value: 2,
    image: CommercialIcon
  },
  {
    label: '',
    value: 3,
    image: IndustrialIcon
  },
  {
    label: '',
    value: 4,
    image: OthersContratcsIcon
  }
];

export const CONTRACT_RELATIONSHIPS = [
  { label: 'Propietario', value: 'owner' },
  { label: 'Arrendatario', value: 'tenant' },
  { label: 'Otro', value: 'other' }
];

export const ChallengeStatus = {
  ToValidate: 'toValidate',
  Validated: 'validated'
};

export const ContractChallengeType = {
  Question: 'question',
  Gelocation: 'geolocation',
  IdentityValidation: 'identityValidation',
  PhoneValidation: 'phone-validation'
};

export const TaskQuestionType = {
  RecentInvoice: 'recent-invoice-id',
  PassKey: 'pass-key-id',
  PhoneValidation: 'phone-validation'
};

export const formatAnswerDataBody = (answers, metadata = false, type) => {
  if (type === TaskQuestionType.PhoneValidation) {
    return [];
  }

  const challengeData = answers.map(challengeAnswer => {
    const { id, answer } = challengeAnswer;
    const data = { id, answer };

    if (metadata) {
      data.metadata = challengeAnswer.metadata;
    }

    return data;
  });

  return challengeData;
};

const SPECIAL_CONTRACT_ICON = 4;
export const getDefaultContractIcon = (type, isSpecial = false) => {
  if (isSpecial || SPECIAL_CONTRACTS.includes(type)) {
    return SPECIAL_CONTRACT_ICON;
  }

  if (INVOICE_CONTRACTS.includes(type)) {
    return type;
  }

  return SPECIAL_CONTRACT_ICON;
};

const SPECIAL_CONTRACT_ALIAS = 'Especial';
export const getDefaultContractAlias = (type, isSpecial = false) => {
  if (isSpecial) {
    return SPECIAL_CONTRACT_ALIAS;
  }

  if (INVOICE_CONTRACTS.includes(type)) {
    return DEFAULT_ALIASES[type];
  }

  return SPECIAL_CONTRACT_ALIAS;
};

export const DeactivationReason = {
  messageDeliveryIssue: 'message-delivery-issue',
  paymentTrouble: 'payment-trouble',
  noInternetAccess: 'no-internet-access',
  prefersPhysicalBill: 'prefers-physical-bill',
  thirdPartyRequirement: 'third-party-requirement',
  other: 'other'
};

export const DactivationReasonLabels = {
  [DeactivationReason.messageDeliveryIssue]:
    'No me llegan los mensajes de WhatsApp/SMS/correos con la factura digital.',
  [DeactivationReason.paymentTrouble]:
    'He tenido problemas para pagar desde que tengo factura digital.',
  [DeactivationReason.noInternetAccess]:
    'No tengo acceso frecuente a internet.',
  [DeactivationReason.prefersPhysicalBill]:
    'Prefiero la factura en físico porque me genera más confianza y seguridad.',
  [DeactivationReason.thirdPartyRequirement]:
    'Necesito la factura física para entregarla a otra persona (ej. arrendador, inquilino).',
  [DeactivationReason.other]: 'Otra razón.'
};

export const isValidDeactivationReason = reason =>
  Object.values(DeactivationReason).includes(reason);

export const isDigitalInvoiceAllowedByContractType = contract => {
  if (!contract) {
    return false;
  }

  return (
    INVOICE_CONTRACTS.includes(contract.type) ||
    contract.productType === CONTRACT_PRODUCT_TYPES.Generic
  );
};

export const isChallengeTypeValid = type => {
  return Object.values(ContractChallengeType).includes(type);
};

export const areTasksValid = (tasks, challengeType) => {
  if (!Array.isArray(tasks) || !tasks.length) {
    return false;
  }

  let taskTypes = {};
  switch (challengeType) {
    case ContractChallengeType.Question:
      taskTypes = TaskQuestionType;
      break;
    default:
      taskTypes = {};
      break;
  }

  return tasks.every(task => Object.values(taskTypes).includes(task.id));
};

// largest contract with bigger direction 48209612, 66329871
// largest titualr 66546899 1509353
